module.exports = __webpack_public_path__ + "img/banner-3-1@2x.f2ca2e15.jpg";